// extracted by mini-css-extract-plugin
export default {"page":"I1","wrapper":"J1","text":"K1","icons":"L1","icon":"M1","icon_text":"N1","carousel_wrapper":"O1","slide":"P1","image":"Q1","arrows":"R1","prev":"S1","modal_root":"T1","x_mark":"U1","modal":"V1","images":"W1","main_image":"X1","name":"Y1"};
    if(module.hot) {
      // 1730991512244
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  